<template>
  <Modal :id="'cmp-add-account'" @cancelled="onCancel">
    <template slot="header"> New Order </template>
    <template slot="body">
      <div class="form-group">
        <Dropdown
          class="m2"
          :options="accountListTV"
          box
          :placeholder="$t('Account')"
          v-on:selectedChange="(e) => onDropdownChange('account_id', e)"
          :listHeight="150"
          :selected="accountListTV.find(e=> e.value == orderData.account_id)"
          deselect
          showValidationIcons
          required
          immediateValidation
          @validated="(e) => onValidation('account_id', e)"
        />
        <Dropdown
          class="m2"
          :options="stockAccountListTV"
          box
          :placeholder="$t('Stock Account')"
          v-on:selectedChange="(e) => onDropdownChange('contra_account_id', e)"
          :listHeight="150"
          :selected="stockAccountListTV.find(e=>e.value==orderData.contra_account_id)"
          deselect
          showValidationIcons
          required
          immediateValidation
          @validated="(e) => onValidation('contra_account_id', e)"
        />
        <TextField
          class="m1"
          :id="'custom_ref'"
          required
          v-bind="textFieldConfig"
          v-model="orderData.order_reference"
          isModel
          :placeholder="$t('customer_ref')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>

        <Dropdown
          class="m2"
          :options="orderTypeListTV"
          box
          :placeholder="$t('type_string')"
          v-on:selectedChange="(e) => onDropdownChange('order_type', e)"
          :listHeight="500"
          :selected="orderTypeListTV.find(e=>e.value==orderData.order_type)"
          deselect
          showValidationIcons
          required
          immediateValidation
          @validated="(e) => onValidation('order_type', e)"
        />
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s7" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button :disabled="!isFormValid" :class="{ disabled: !isFormValid }" class="dt-button v1 with-ico s7" @click.stop="onAddOrder">
        <div class="dt-icon-container">
          <img src="static/icons/plus-white.svg" class="dt-icon v7" alt />
        </div>
        <div class="button-text">
          {{ $t("add_orders") }}
        </div>
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as AccountActionTypes from "../../store/accounts/types";
import { DistributionStoreNamespace as storeNS } from "../../store";
import { OrderService } from "../../services/order.service";
import { createTextFieldConfig, EventHooks } from "@plugins/text-field";
export default {
  components: {
    Modal,
  },
  props: {},
  data: function () {
    return {
      orderTypeList: [],
      stockAccountList: [],
      accountList: [],
      orderData: {
        account_id: 0,
        order_reference: "",
        order_type: 0,
        contra_account_id: 0,
      },
      selectedAccount: {},
      selectedOrderType: {},
      selectedStockAccount: {},
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },
      validationResult: {},
      // Mark: Data
    };
  },
  watch: {},
  mounted: function () {
    OrderService.getNewOrderData().then((res) => {
      this.orderTypeList = res.data.order_types;
      this.stockAccountList = res.data.contra_accounts;
      this.accountList = res.data.accounts.filter(
        (a) => a.account_name !== null
      );
      console.log("::::::",this.orderTypeList,this.stockAccountList, this.accountList) 
      this.orderData.account_id = this.accountList[0].account_id;
      this.orderData.order_type = this.orderTypeList[0].value;
      this.orderData.contra_account_id = this.stockAccountList[0].account_id;
    });
  },

  watch: {},
  computed: {
    accountListTV:function(){
      return this.accountList.map((x) => ({
              text: x.account_name,
              value: x.account_id,
            }))
    },

    stockAccountListTV:function(){
      return this.stockAccountList.map((x) => ({
              text: x.account_name,
              value: x.account_id,
            }))
    },

    orderTypeListTV:function(){
      return  this.orderTypeList.map((x) => ({ text: x.label, value: x.value }))
    },
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },

  },
  methods: {
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    onTextFieldValueChange: function (name, value) {
      console.log(name, value);
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },

    onAddOrder() {
      this.$emit("added", this.orderData);
    },
    onDropdownChange(action, data) {
      this['orderData'][action]=data.value
      // if (action === "account") {
      //   this.orderData.account_id = data.value;
      //   this.selectedAccount = data;
      // } else if (action === "stock_account") {
      //   this.orderData.contra_account_id = data.value;
      //   this.selectedStockAccount = data;
      // } else {
      //   this.orderData.order_type = data.value;
      //   this.selectedOrderType = data;
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox-container {
  display: flex;
  flex-direction: row;
}
.dt-checkbox-control {
  display: flex;
  margin: 5px;
  height: 39px;
  padding-right: 10px;
  .dt-checkbox {
    padding-top: 5px;
  }
  .dt-checkbox-label {
    padding-left: 5px;
  }
  .checkmark {
    top: 3px;
  }
}
button {
  height: 2.5em;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  border-radius: 5px;
}
</style>
